export default `
<svg width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true" aria-label="evisort-ai-animated">
    <image width="28px" height="28px" href="/evisort-ai-animated.gif" />
</svg>
`;
